import { render, staticRenderFns } from "./PaymentCountdown.vue?vue&type=template&id=6234631e"
import script from "./PaymentCountdown.vue?vue&type=script&lang=js"
export * from "./PaymentCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports